module.exports = __webpack_public_path__ + "img/ça-m'impressionne.39ab2d0a.png";